import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';

import { FOR_BANK_SECTIONS, FOR_BANK_SUB_SECTIONS } from 'constants/businessToolSections/forBank';
import { debounce } from 'lodash';

import useCheckSubSectionAccess from 'hooks/useCheckSubSectionAccess';

import {
  calculatePeriodValueBaseOnPreviousPeriod,
  PERIODS_OPERATION_TYPES,
  summarizeSubtractPeriodValues,
} from 'components/BusinessToolForm/utils/helpers';

import { observedFields } from '../../utils/form';

export const useGetLongTermDebtCalculation = () => {
  const { setValue } = useFormContext();

  const canAccess = useCheckSubSectionAccess(
    FOR_BANK_SECTIONS.MARKETING_AND_SALES,
    FOR_BANK_SUB_SECTIONS.FOR_BANK_MARKETING_AND_SALES.SALES_PLAN,
  );

  const [longTermDebtFiled] = observedFields.longTermDebt.setCalculatedValueFieldNames;

  const getLongTermDebtCalculationHandler = useMemo(
    () =>
      debounce((content) => {
        if (!canAccess) return;

        const [initialLongTermDebt, proceedsOfDebt, repaymentOfDebt] = content;
        const calculatedDebt = summarizeSubtractPeriodValues(
          [proceedsOfDebt, repaymentOfDebt],
          PERIODS_OPERATION_TYPES.ADD,
        );
        const longTermDebt = calculatePeriodValueBaseOnPreviousPeriod(calculatedDebt, initialLongTermDebt);

        setValue(longTermDebtFiled, longTermDebt);
      }, 500),
     
    [],
  );

  return getLongTermDebtCalculationHandler;
};
